import {CATEGORY_SUCCESS, CATEGORY_ERROR} from '../actions/category';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === CATEGORY_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === CATEGORY_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}